import * as React from "react";
import ImageList from "@mui/material/ImageList";
import ImageListItem from "@mui/material/ImageListItem";
import image1 from "../images/cochabamba/image1.jpg";
import image2 from "../images/cochabamba/image2.jpg";
import image3 from "../images/cochabamba/image3.jpg";
import image4 from "../images/cochabamba/image4.jpg";
import image5 from "../images/cochabamba/image5.jpg";
import image6 from "../images/cochabamba/image6.jpg";
import image7 from "../images/cochabamba/image7.jpg";

export default function GaleriaCochabamba() {
  const [screenSize, setScreenSize] = React.useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  React.useEffect(() => {
    // Función para actualizar el tamaño de la pantalla
    const handleResize = () => {
      setScreenSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };

    // Agregar el evento de redimensionamiento
    window.addEventListener("resize", handleResize);

    // Eliminar el evento para evitar fugas de memoria
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  return (
    <ImageList
      sx={{
        height: 450,
      }}
      cols={screenSize.width >= 600 ? 3 : 2}
      rowHeight={200}
    >
      {itemData.map((item) => (
        <ImageListItem key={item.img}>
          <img
            srcSet={`${item.img}?w=164&h=164&fit=crop&auto=format&dpr=2 2x`}
            src={`${item.img}?w=164&h=164&fit=crop&auto=format`}
            alt={item.title}
            loading="lazy"
          />
        </ImageListItem>
      ))}
    </ImageList>
  );
}

const itemData = [
  {
    img: image5,
    title: "Ambientes DLS La Paz",
  },
  {
    img: image2,
    title: "Burger",
  },
  {
    img: image3,
    title: "Camera",
  },
  {
    img: image7,
    title: "Coffee",
  },
  {
    img: image1,
    title: "Hats",
  },
  {
    img: image6,
    title: "Honey",
  },
  {
    img: image4,
    title: "Basketball",
  },
];
